/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { createContext, useEffect, useMemo, useState } from 'react'
import { Container } from '@mui/system'

// @components
import Pageheader from '../../components/PageHeader'
import {
  FileDownloadOutlinedIcon,
  Button,
  Box
} from '../../components/shared/MaterialUI'
import MenuDownloadFile from './components/MenuDownloadFile'
import UploadFile from './components/UploadFile'
import FileTable from './components/FileTable'

// @assets
import { GeneralStyles } from '../../assets/css/general-style'
import { theme } from '../../assets/theme'

// @hooks
import UseFile from './hooks/UseFile'

const FilePage = () => {
  const generalStyle = useMemo(() => GeneralStyles(), []);  
  const [anchorElMenu, setAnchorElMenu] = useState(null);
  const openMenu = Boolean(anchorElMenu);

  const {
    categories,
    rowsState,
    setRowsState,
    fetchCategories,
    fetchFiles,
    filter,
    setFilter
  } = UseFile();

  const handleClickMenuTemplate = (e) => {
    setAnchorElMenu(e.currentTarget);
  }

  const handleCloseMenu = () => {
    setAnchorElMenu(null);
  };
  
  useEffect(() => {
    fetchFiles();
    fetchCategories();
  }, [])

  return (
    <Container
      component="section"
      maxWidth="xl"
      sx={generalStyle.dashCtn}
    >
      <Container
        component="section"
        maxWidth="xl"
        sx={generalStyle.containerTitle}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            [theme.breakpoints.down('sm')]: {flexDirection: 'column', alignItems: 'flex-start', gap: '10px'}
          }}
        >
          <Pageheader
            title="Upload File"
            subtitle="Welcome to the file upload dashboard"
          />

          <Button
            sx={{
              ...generalStyle.customButton,
              ...generalStyle.customButtonSm,
              paddingX: '10px',
              width: '150px',
              [theme.breakpoints.down('sm')]: {width: '100%'}
            }}
            endIcon={<FileDownloadOutlinedIcon />}
            onClick={(e) => handleClickMenuTemplate(e)}
          >
            Template
          </Button>
        </Box>
      </Container>

      <Container
        component="section"
        maxWidth="xl"
      >
        <FilePageContext.Provider
          value={{
            rowsState,
            setRowsState,
            fetchFiles,
            categories,
            filter,
            setFilter
          }}
        >
          <UploadFile/>
          <FileTable/>
        </FilePageContext.Provider>
      </Container>

      <MenuDownloadFile
        anchorElMenu={anchorElMenu}
        openMenu={openMenu}
        handleCloseMenu={handleCloseMenu}
      />
    </Container>
  )
}

export const FilePageContext = createContext({});
export default FilePage